"use client";
import { AppStore, makeStore } from "@/libs/store";
import { useEffect, useRef, useState } from "react";
import { Provider } from "react-redux";
import Loading from "./loading";

export default function StoreProvider({ children }: { children: React.ReactNode }) {
  const storeRef = useRef<AppStore | null>(null);

  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = makeStore();
  }

  const [isNavigating, setIsNavigating] = useState(false);

  const onRouteChangeStart = () => {
    setIsNavigating(true);
  };

  const onRouteChangeComplete = () => {
    setIsNavigating(false);
  };

  // Listen for client-side navigation events
  useEffect(() => {
    window.addEventListener("beforeunload", onRouteChangeStart);
    return () => {
      window.removeEventListener("beforeunload", onRouteChangeStart);
    };
  }, []);

  return (
    <Provider store={storeRef.current}>
      {isNavigating && <Loading onRouteChangeComplete={onRouteChangeComplete}/>}
      {children}
    </Provider>
  );
}
